
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Maintenance } from './maintenance';
import { Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { NewMaintenance } from '../maintenance-create/newmaintenance';

@Injectable({ providedIn: 'root' })
export class MaintenanceService {
    constructor(private http: HttpClient) {
    }

    maintenanceUrl = environment.appURL + "/maintenances";
    maintenanceGqlUrl = environment.graphURL;

    getMaintenances() {
        return this.http.get<Maintenance[]>(this.maintenanceUrl, {headers: new HttpHeaders({"Authorization":"Bearer " + environment.token})})
            .pipe(
                tap(_ => { }),
                catchError(this.handleError('getMaintenance', []))
            );
    }

    getMaintenanceById(id: number) {
        const url = `${this.maintenanceUrl}/${id}`;

        return this.http.get<Maintenance>(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) })
            .pipe(
                tap(_ => { }),
                catchError(this.handleError<Maintenance>(`getMaintenance id=${id}`))
            );
    }

    getMaintenacneGql(id: number) 
    {
        const url = this.maintenanceGqlUrl + "{maintenance(id:\"" + id + "\"){ id user{ id username firstname lastname} dateofvisit machine{id shortname serialnumber state{statevalue} counter machinetype{type} client{id name} imageurl location{addr1 City Country contact_name phone_number email  }} client{id name} visitdetails counter}}";
        return this.http.get(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) })
            .pipe(map(data => data['data']['maintenance']));
    }


    getMaintenacneGqlByMachineId(id: number) 
    {
        const url = this.maintenanceGqlUrl + "{maintenances (where : {machine:\"" + id + "\"}){ id user{ id username firstname lastname} dateofvisit machine{ id shortname serialnumber location{id addr1}} client{id name} visitdetails counter}}";
        return this.http.get(url, { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token }) })
            .pipe(map(data => data['data']['maintenances']));
    }


    createMaintenance(newMaintenance: NewMaintenance ) {
        var upd = JSON.stringify(newMaintenance);
        
        return this.http.post<NewMaintenance>(`${environment.appURL}/maintenances/`,  upd , {headers: new HttpHeaders({"Authorization":"Bearer " + environment.token, "Content-Type": "application/json"})})  ;
        }
      


    

        getMaintenanceByCriteria(criteria: string, cvalue: string, client : number, jwt : string)
    
        {
          const url = environment.graphURL + "{maintenances (where:{client:" + client + ","+ criteria + "_contains:\"" + cvalue + 
          "\"}){id dateofvisit visitdetails machine{id shortname serialnumber} counter user{id username firstname lastname} client{id name} }}";
            
          return this.http.get( url,{headers: new HttpHeaders({"Authorization":"Bearer " + jwt})})
          .pipe(map(data => data['data']['maintenances'])
          );
            
        }
        
        getMaintenanceByCriteriaAdmin(criteria: string,  cvalue: string,jwt : string)
        
        {
          const url = environment.graphURL + "{maintenances (where:{" + criteria + "_contains:\"" + cvalue + 
          "\"}){id dateofvisit visitdetails machine{id shortname serialnumber} counter user{id username firstname lastname} client{id name} }}";
            
          return this.http.get( url,{headers: new HttpHeaders({"Authorization":"Bearer " + jwt})})
          .pipe(map(data => data['data']['maintenances'])
          );
            
        }

//-----------------------------------------------------------
// UPDATE MAINTENANCE DETAIL 
//-----------------------------------------------------------
        updateMaintenance(detail : string, PMRid: number, PMRcounter :number) 
        {
            let updates = {visitdetails: detail, counter : PMRcounter };
            var urlcommand = this.maintenanceUrl + "/" + PMRid;
            return this.http.put(urlcommand, JSON.stringify(updates), { headers: new HttpHeaders({ "Authorization": "Bearer " + environment.token, "Content-Type": "application/json" }) });
       
        }

    

    private handleError<T>(operation = 'operation', result?: T) {
        return (error: any): Observable<T> => {

            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead

            // TODO: better job of transforming error for user consumption
            console.log(`${operation} failed: ${error.message}`);

            // Let the app keep running by returning an empty result.
            return of(result as T);
        };
    }

    getClientMaintenance(clientId : number)
    {
      var query = "{maintenances (where:{ client:" + clientId + "}){id dateofvisit visitdetails machine{id shortname serialnumber} counter user{id username firstname lastname} client{id name} }}"
     const url = environment.graphURL + query;
    return this.http.get<Maintenance[]>( url,{headers: new HttpHeaders({"Authorization":"Bearer " + environment.token})})
     .pipe(map(data => data['data']['maintenances'])
     );
      }
        


}
